// start app
var popup = vueIfExists({
  el: '#popup',
  data: {
    content: '',
    iframeSrc: '',
    isText: true,
    panelHeight: 600,
    posTop: 0,
    isLarge: true
  },
  methods: {
  	show: function(iframeSrc, text, config) {
  		config = config || {};

		this.isLarge = true;

		if (config.type == 'small') {
			this.panelHeight = 350;
			this.isLarge = false;
		} else if (config.height) {
			this.panelHeight = config.height;
		} else {
			this.panelHeight = 600;
		}

		this.isText = !!text;
		if (iframeSrc) {
			this.iframeSrc = iframeSrc;
		} else {
			this.content = text;
		}

		if (this.panelHeight + 40 > window.innerHeight) {
			this.posTop = 20 + window.pageYOffset;
			this.panelHeight = window.innerHeight - 40;
		} else {
			this.posTop = (window.innerHeight - this.panelHeight) /2 + window.pageYOffset;
		}
		$d.fadeIn(this.$el, 0.4);
	},
	close: function($event, type) {
		if (type == 'closeBtn') {
			$event.preventDefault();
		}
		$d.fadeOut(this.$el, 0.4);
	}
  }
});

